import { useEffect, useState } from "react";

// Countdown hero slide: "Upcoming TOPIK 1:N Live Class" with Days/Hours/Min/Sec
// + Level / Opening Date / Format meta row + two CTA buttons.
function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  const s = Math.floor(ms / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}
const pad = (n) => String(n).padStart(2, "0");

export default function HeroCountdown({ props }) {
  const target = props?.targetDate;
  const [t, setT] = useState(() => (target ? diff(target) : { days: 0, hours: 0, minutes: 0, seconds: 0 }));

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { v: t.days, label: props?.daysLabel || "Days" },
    { v: t.hours, label: props?.hoursLabel || "Hours" },
    { v: t.minutes, label: props?.minutesLabel || "Minutes" },
    { v: t.seconds, label: props?.secondsLabel || "Seconds" },
  ];

  const meta = [
    { label: props?.levelLabel || "Level", value: props?.levelValue },
    { label: props?.openingLabel || "Opening Date", value: props?.openingValue },
    { label: props?.formatLabel || "Format", value: props?.formatValue },
  ].filter((m) => m.value);

  return (
    <div className="hero-countdown">
      {props?.title && <h2 className="hero-countdown__title">{props.title}</h2>}

      <div className="hero-countdown__timer">
        {units.map((u, i) => (
          <div className="hero-countdown__cell" key={i}>
            <span className="hero-countdown__num">{pad(u.v)}</span>
            <span className="hero-countdown__unit">{u.label}</span>
          </div>
        ))}
      </div>

      {meta.length > 0 && (
        <div className="hero-countdown__meta">
          {meta.map((m, i) => (
            <div className="hero-countdown__meta-item" key={i}>
              <span className="hero-countdown__meta-label">{m.label}</span>
              <span className="hero-countdown__meta-value">{m.value}</span>
            </div>
          ))}
        </div>
      )}

      <div className="hero-countdown__cta">
        {props?.primaryCtaLabel && (
          <a className="hero-countdown__btn hero-countdown__btn--primary" href={props?.primaryCtaLink || "#"}>
            {props.primaryCtaLabel}
          </a>
        )}
        {props?.secondaryCtaLabel && (
          <a className="hero-countdown__btn hero-countdown__btn--ghost" href={props?.secondaryCtaLink || "#"}>
            {props.secondaryCtaLabel}
          </a>
        )}
      </div>
    </div>
  );
}
